import * as React from 'react';

type CompactPriceType = {
    price?: number;
    className?: string;
    currency?: string;
    fractionDigits?: number;
};

const CompactPrice = (props: CompactPriceType) => {
    const priceFormatter = Intl.NumberFormat('en', {
        notation: 'compact',
        minimumFractionDigits: props.fractionDigits || 2,
        maximumFractionDigits: props.fractionDigits || 2,
        currency: props.currency || 'USD',
    });

    if (!props.price) {
        return null;
    }

    return <span className={props.className}>${priceFormatter.format(props.price)}</span>;
};

export default CompactPrice;
